import { ApiError } from '../../api/client';
import { dateLocale } from '../../i18n';

type T = (key: string, options?: Record<string, unknown>) => string;

export function apiErrorText(error: unknown, t: T): string | null {
  if (!error) return null;
  const code = error instanceof ApiError ? error.code : undefined;
  return t(`apiErrors.${code ?? 'unknown'}`, { defaultValue: t('apiErrors.unknown') });
}

/** "today", "yesterday", "5 days ago", "2 months ago", in the interface language. */
export function relativeTime(iso: string, t: T): string {
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / (24 * 60 * 60 * 1000));
  if (days <= 0) {
    const hours = Math.floor((Date.now() - new Date(iso).getTime()) / (60 * 60 * 1000));
    return hours < 1 ? t('admin.time.justNow') : hours < 12 ? t('admin.time.hoursAgo', { count: hours }) : t('admin.time.today');
  }
  if (days === 1) return t('admin.time.yesterday');
  const rtf = new Intl.RelativeTimeFormat(dateLocale(), { numeric: 'auto' });
  if (days < 31) return rtf.format(-days, 'day');
  if (days < 365) return rtf.format(-Math.floor(days / 30), 'month');
  return rtf.format(-Math.floor(days / 365), 'year');
}
